import {
    ReactFlow,
    MiniMap,
    Controls,
    Background,
} from "@xyflow/react";
import { BiCommentAdd, BiPlay, BiPlus } from "react-icons/bi";
import OverDropdown from "./OverDropdown";
import { MdClose } from "react-icons/md";
import {
    applyNodeChanges,
    applyEdgeChanges
} from "@xyflow/react";
import { useState } from "react";
import { TbClipboardPlus } from "react-icons/tb";
import CustomConnectionLine from "./CustomConnectionLine";
import ModalInputWorkflows from "./ModalInputWorkflows";

const GRID_SIZE = 14;

const FlowFrame = ({
    mcpData,
    fetchMcpData,
    loadingMcpData,
    dropdownRef,
    openOverDropdown,
    setOpenOverDropdown,
    onSelectNode,
    toggleOverDropdown,
    nodes,
    setSelectedNodeId,
    setSelectedNode,
    selectedNode,
    edges,
    nodeTypes,
    typeNodeTrigger,
    onNodesChange,
    onEdgesChange,
    onEdgesDelete,
    onConnect,
    orderedNodes,
    openInputWorkflow,
    setOpenInputWorkflow,
    selectedItem,
    setSelectedItem,
    executeNode,
    executionHistory
}) => {

    const newNote = () => {
        const notesItem = {
            value: "note",
            label: "Note",
            description: "Notes help you keep your ideas organized and make it easier for others to understand how your workflow works."
        }

        setOpenInputWorkflow(true)
        setSelectedItem(notesItem)
    }

    return (
        <div>
            <OverDropdown
                mcpData={mcpData}
                fetchMcpData={fetchMcpData}
                loadingMcpData={loadingMcpData}

                openInputWorkflow={openInputWorkflow}
                setOpenInputWorkflow={setOpenInputWorkflow}

                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}

                ref={dropdownRef}
                show={openOverDropdown}
                setOpenOverDropdown={setOpenOverDropdown}
                typeNodeTrigger={typeNodeTrigger}
            />

            <div className="workflow_tools_cont">
                <div className="workflow_tools_cont_inner">

                    <button
                        className="new_automation_btn"
                        onClick={toggleOverDropdown}
                    >
                        {openOverDropdown ? (
                            <i className="fade-in">
                                <MdClose />
                            </i>
                        ) : (
                            <i className="fade-in">
                                <BiPlus />
                            </i>
                        )}
                    </button>

                    <button className="new_automation_btn" onClick={newNote}>
                        <i><TbClipboardPlus /></i>
                    </button>

                    <button className="new_automation_btn">
                        <i><BiPlay /></i>
                    </button>

                </div>
            </div>

            <div
                className="readt_flow_cont fade-in"
            >
                <ReactFlow
                    nodes={nodes}
                    edges={edges}
                    nodeTypes={nodeTypes}
                    onNodesChange={onNodesChange}
                    onEdgesChange={onEdgesChange}
                    onEdgesDelete={onEdgesDelete}
                    onConnect={onConnect}
                    panOnDrag={true}
                    selectionOnDrag={false}
                    selectionKeyCode="Control"
                    deleteKeyCode="Backspace"
                    proOptions={{ hideAttribution: true }}
                    connectionLineComponent={CustomConnectionLine}
                    onNodeDoubleClick={(event, node) => {
                        if (node.type === "default") return;
                        setSelectedNodeId(node.id);
                        setSelectedNode(node);
                        setOpenInputWorkflow(true);
                        const item = {
                            value: node?.data?.config?.value,
                            label: node?.data?.config?.label,
                            description: node?.data?.config?.description,
                        }
                        setSelectedItem(item)
                    }}
                >
                    <MiniMap
                        style={{
                            backgroundColor: "var(--lightGrey)",
                            borderRadius: "20px",
                        }}
                        nodeColor={() => "var(--originalBlack)"}
                        maskColor={"transparent"}
                        pannable={false}
                        zoomable={false}
                    />

                    <Controls className="workflow-controls" />

                    <Background
                        variant="dots"
                        gap={GRID_SIZE}
                    />
                </ReactFlow>
            </div>

            <ModalInputWorkflows
                orderedNodes={orderedNodes}
                show={openInputWorkflow}
                handleClose={() => setOpenInputWorkflow(false)}
                selectedItem={selectedItem}
                selectedNode={selectedNode}
                onSelectNode={onSelectNode}
                setSelectedNode={setSelectedNode}
                setSelectedNodeId={setSelectedNodeId}
                setOpenOverDropdown={setOpenOverDropdown}
                mcpData={mcpData}
                fetchMcpData={fetchMcpData}
                loadingMcpData={loadingMcpData}
                executeNode={executeNode}
                executionHistory={executionHistory}
            />
        </div>
    );
};

export default FlowFrame;